'use client';

import { ThemeProvider, useTheme } from 'next-themes';
import type { ThemeProviderProps } from 'next-themes';
import * as React from 'react';

export interface ColorModeProviderProps extends ThemeProviderProps {}

export type ColorMode = 'light' | 'dark';

export function ColorModeProvider(props: ColorModeProviderProps) {
  return (
    <ThemeProvider
      { ...props }
      attribute="class"
      scriptProps={{ 'data-cfasync': 'false' }}
      defaultTheme="light"
      forcedTheme="light"
      enableSystem={ false }
      disableTransitionOnChange
    />
  );
}

export function useColorMode() {
  const { setTheme } = useTheme();
  const toggleColorMode = () => setTheme('light');
  return {
    colorMode: 'light' as ColorMode,
    setColorMode: (colorMode: ColorMode) => {
      void colorMode;
      setTheme('light');
    },
    toggleColorMode,
  };
}

export function useColorModeValue<T>(light: T, dark: T) {
  void dark;
  return light;
}
